export const loadingHTML = `<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Loading...`;
export const loading = `Loading...`;
export function Detail(abc){
    return(
        <>Chi tiết <i className="bi bi-info-circle"></i></>
    )
};